// src/utils/geoUtils.js

/**
//  * Calculate the great-circle distance between two coordinates (Haversine formula)
//  * @returns distance in kilometres
//  */

export function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  const R = 6371; // Radius of the earth in km
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) *
    Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in km
}

/**
 * Add distance (in km) to every item in an array and sort ascending.
 * Expects each item to have postedBy.latitude & postedBy.longitude.
 * If location is null/undefined, returns the original array.
 */
export function sortOffersByDistance(items, location) {
  if (!location) return items;

  return items
    .map((item) => {
      const lat = item?.postedBy?.latitude;
      const lon = item?.postedBy?.longitude;
      if (
        typeof lat === "number" && !isNaN(lat) &&
        typeof lon === "number" && !isNaN(lon)
      ) {
        const dist = getDistanceFromLatLonInKm(
          location.lat,
          location.lon,
          lat,
          lon
        );
        return { ...item, distance: dist };
      }
      return { ...item, distance: null };
    })
    .sort((a, b) => {
      if (a.distance == null && b.distance == null) return 0;
      if (a.distance == null) return 1;
      if (b.distance == null) return -1;
      return a.distance - b.distance;
    });
}

export function sortHotelByDistance(shops, location) {
    if (!location) return shops;
    return shops
        .map((s) => {
            const lat = s?.latitude;
            const lon = s?.longitude;
            if (
                typeof lat === "number" && !isNaN(lat) &&
                typeof lon === "number" && !isNaN(lon)
            ) {
                const dist = getDistanceFromLatLonInKm(
                    location.lat,
                    location.lon,
                    lat,
                    lon
                );
                return { ...s, distance: dist };
            }
            return { ...s, distance: null };
        })
        .sort((a, b) => {
            if (a.distance == null && b.distance == null) return 0;
            if (a.distance == null) return 1;
            if (b.distance == null) return -1;
            return a.distance - b.distance;
        });
}
